import { cn } from '@/lib/utils';

/**
 * The single public-site content column. Sections are full-bleed (their
 * backgrounds/decorators reach the viewport edge); their *content* goes in a
 * Container so every section aligns to the same gutters. One source of truth
 * for page margins — keeps the layout logical and consistent.
 */
const widths = { default: 'max-w-6xl', wide: 'max-w-7xl' } as const;

export function Container({
  children,
  className,
  size = 'default',
}: {
  children: React.ReactNode;
  className?: string;
  /** `wide` (max-w-7xl) gives the header room for the full nav. */
  size?: keyof typeof widths;
}) {
  return <div className={cn('mx-auto w-full px-6 sm:px-10 lg:px-14', widths[size], className)}>{children}</div>;
}
